import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))

window.author = `
  ┌────────────────┐
┌─┤ Development by ├───────────────┐
│ └────────────────┘               │
│   <···>                          │
│   Marcin Kalinowski              │
│   https://marcin-kalinowski.pl   │
│                                  │
└──────────────────────────────────┘
`